import type { LanguageCode } from "../hooks/useLanguage";
import { customers } from "../config/customers";
import { getCustomerKey } from "./domain";

const DEFAULT_BLOG_BASE = {
  de: "blog",
  en: "news"
} as const;

const trimSlashes = (value: string) => value.replace(/^\/+|\/+$/g, "");

export const getBlogBaseSlug = (lang: LanguageCode, customerKey = getCustomerKey()) => {
  const configured = customers[customerKey]?.blogBase?.[lang] || DEFAULT_BLOG_BASE[lang];
  const normalized = trimSlashes(configured || "");
  return normalized || DEFAULT_BLOG_BASE[lang];
};

export const getBlogBasePath = (lang: LanguageCode, customerKey = getCustomerKey()) => {
  const base = getBlogBaseSlug(lang, customerKey);
  return lang === "en" ? `/en/${base}` : `/${base}`;
};

export const getBlogItemPath = (slug: string, lang: LanguageCode, customerKey = getCustomerKey()) => {
  const safeSlug = trimSlashes(slug || "");
  return `${getBlogBasePath(lang, customerKey)}/${safeSlug}`;
};
